:host {
  display: block;
}

button {
  border: none;
  outline: inherit;
  background-color: #2e5276;
  color: #fff;
  height: 48px;
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
  letter-spacing: 0.4px;
  line-height: 21px;
}

button:hover {
  background-color: #457ab0;
}
